// extracted by mini-css-extract-plugin
module.exports = {"container":"container__2_eEF","flexCenter":"flex-center__dZ0Oo","image":"image__1u0O4","textContainer":"text-container__1HVvn","welcomeMessage":"welcome-message__3YI2k"};